import { AllFlags, environment, finalizedFlags, flags } from 'environment';
import { AppNet } from 'networking';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { devtools, getStorage } from './helpers';

interface FlagState {
  flags: AllFlags;

  setFlags: (flags: AllFlags) => void;

  _rehydrated: boolean;
  _setRehydrated: (_rehydrated: boolean) => void;

  _lastUpdated: number;

  fetchFlags: (force?: boolean) => Promise<AllFlags>;
}

export const useFlags = create<FlagState>()(
  devtools(
    persist(
      (set, get) => ({
        flags,

        setFlags: (flags: AllFlags) => set(s => ({ ...s, flags })),

        _rehydrated: false satisfies boolean,
        _setRehydrated: _rehydrated => set(s => ({ ...s, _rehydrated })),

        _lastUpdated: 0,

        fetchFlags: async (force?: boolean) => {
          if (get()._lastUpdated > Date.now() - 1000 * 60 * 1 && !force) return get().flags;
          const res = await AppNet.flags.get();
          if (res.success === false) return get().flags;

          const flags = { ...finalizedFlags, ...res.data };
          set(s => ({ ...s, flags, _lastUpdated: Date.now() }));
          return flags;
        },
      }),
      {
        name: `b4k-${environment.name}-flags`,
        version: 1,
        onRehydrateStorage: () => state => state._setRehydrated(true),
        storage: getStorage(),
      },
    ),
    { name: 'flags' },
  ),
);
